import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
interface SectionHeadingProps {
  id: string;
  title: string;
  subtitle?: string;
  link?: {
    href: string;
    label: string;
  };
}
export function SectionHeading({
  id,
  title,
  subtitle,
  link
}: SectionHeadingProps) {
  return <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-104" data-mp="3k06y7yjxd00d">
      <div className="max-w-2xl" data-id="element-105" data-mp="3k202x8az9a5q">
        <h2 id={id} className="font-display text-3xl font-semibold tracking-tight md:text-4xl" data-id="element-106" data-mp="bk3nfjximv7t">
          {title}
        </h2>
        {subtitle && <p className="mt-3 text-base text-muted md:text-lg" data-id="element-107" data-mp="giop7nsf1myd">{subtitle}</p>}
      </div>
      {link && <a href={link.href} target="_blank" rel="noopener noreferrer" className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-bold text-paper transition-colors duration-150 hover:text-ember" data-id="element-108" data-mp="1uae6pkuis6q">
          {link.label}
          <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-109" data-mp="zb92vxzjnlhl" />
        </a>}
    </div>;
}